<template>
    <div>
        <span style="display: block;">Days of Week</span>
        <v-checkbox class="week-day" v-model="$props.threshold.thres_days_sun" label="Sunday" color="#c42111"></v-checkbox>
        <v-checkbox class="week-day" v-model="$props.threshold.thres_days_mon" label="Monday" color="#c42111"></v-checkbox>
        <v-checkbox class="week-day" v-model="$props.threshold.thres_days_tue" label="Tuesday" color="#c42111"></v-checkbox>
        <v-checkbox class="week-day" v-model="$props.threshold.thres_days_wed" label="Wednesday" color="#c42111"></v-checkbox>
        <v-checkbox class="week-day" v-model="$props.threshold.thres_days_thu" label="Thursday" color="#c42111"></v-checkbox>
        <v-checkbox class="week-day" v-model="$props.threshold.thres_days_fri" label="Friday" color="#c42111"></v-checkbox>
        <v-checkbox class="week-day" v-model="$props.threshold.thres_days_sat" label="Saturday" color="#c42111"></v-checkbox>
        <v-checkbox class="week-day" v-if="$props.threshold.prev_month !== undefined" v-model="$props.threshold.prev_month" label="Previous Month" color="#c42111"></v-checkbox>
    </div>
</template>

<script>
export default {
  name: 'DaysOfWeek',
  props: ['threshold'],
  data: () => ({
  }),

  computed: {
    
  },

  methods: {
  },

  mounted() {

  }

  
};
</script>

<style scoped>

    .chip-selected {
        background-color: #c42111;
        color: #c42111;
        /* opacity: 1 !important; */

    }

    .week-day {
        display: inline-block;
        margin-right: 3em;
    }


</style>
